import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://dashboard-api.socialpawsapp.com/'
});


export default instance;
